<template>
	<div class="page">
		<div class="pageTitleBox" style="align-items: center;">
			<div class="boxNameL">
				编辑驱虫套餐
			</div>
			<el-button type="warning" @click="isBack" size="small">返回</el-button>
			<!-- <div class="boxNameR">
				<el-button type="warning" @click="isBack" size="small">返回</el-button>
			</div> -->
		</div>
		<div class="wrap">
			<el-form ref="form" style="padding-bottom: 80px;" :model="editParams" label-width="100px" :rules='rules'>
				<div class="tit">
					<span class="name">基础设置</span>
				</div>
				<el-form-item label="分类">
					<el-cascader size="mini" filterable ref="cascader" clearable v-model="productTypeIds" :options="categoryData[1].children"
					:show-all-levels="true" :props="{ label: 'label',value:'id' }" @change="changeCategory"></el-cascader>
				</el-form-item>
				<el-form-item label="套餐名称" prop="title">
					<el-input v-model="editParams.title" size="mini" style="width: 200px;" placeholder="请输入商品描述"></el-input>
				</el-form-item>
				<el-form-item label="适用品种" prop="applyType">
					<el-radio-group v-model="editParams.applyType">
						<el-radio label="0">通用</el-radio>
						<el-radio label="1">猫用</el-radio>
						<el-radio label="2">犬用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否复购">
					<el-radio-group v-model="editParams.buy_back">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="线上线下">
					<el-radio-group v-model="editParams.group_type">
						<el-radio label="1">线上</el-radio>
						<el-radio label="0">线下</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否参与提成">
					<el-radio-group v-model="editParams.join_commission">
						<el-radio :label="Number('0')">否</el-radio>
						<el-radio :label="Number('1')">是</el-radio>
					</el-radio-group>
				</el-form-item>
				<storeSelect v-if='showShops' title='应用门店' :storeIds='storeIds' @sendStore='getStores'></storeSelect>
				<div class="tit">
					<span class="name">设置服务项</span>
				</div>
				<el-form-item label="项目类型" >
					<el-radio-group v-model="editParams.buyWay">
						<el-radio label="0">买赠</el-radio>
						<el-radio label="1">折扣</el-radio>
						<el-radio label="2">自定义</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="结算后订单是否可更换"  label-width="180px">
					<el-radio-group v-model="editParams.checkout_replace.support_replace">
						<el-radio :label="Number(0)">否</el-radio>
						<el-radio :label="Number(1)">是</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="结算订单后更换折扣率" v-if="editParams.checkout_replace.support_replace==1" 
				label-width="180px">
					<el-input-number size="mini" v-model="editParams.checkout_replace.replace_discount_rate" :min="0" :max="1" label="描述文字"></el-input-number>
					<span style="margin-left: 5px;color: #e6a23c;">折扣率请输入0-1之间的数字</span>
				</el-form-item>
				<el-form-item label="设置次数" >
					<div v-for="(item,index) in editParams.buy_options" :key='index'>
						买体外
						<el-input size="mini" style="width: 100px; vertical-align: middle;" placeholder="请输入内容" v-model="item.times">
							<template slot="append">次</template>
						</el-input>
						<span style="margin: 0 10px;">{{editParams.buyWay==0?'赠体内':(editParams.buyWay==1?'折扣率':'价格区间')}}</span>
						<el-input v-if="editParams.buyWay==0" size="mini" style="width: 100px;vertical-align: middle;" placeholder="请输入内容" v-model="item.give_times">
							<template slot="append" >次</template>
						</el-input>
						<el-input-number v-if="editParams.buyWay==1" size="mini" style="width: 100px;" v-model="item.discount_rate" :min="0" :max="1" label="描述文字"></el-input-number>
						<span v-if="editParams.buyWay==1" style="margin-left: 5px;color: #e6a23c;">折扣率请输入0-1之间的数字</span>
						<span v-if="editParams.buyWay==2">
							<el-input   size="mini" style="width: 120px;" v-model="item.min_price " placeholder="请输入最小价格"></el-input>
							-
							<el-input  size="mini" style="width: 120px;" v-model="item.max_price" placeholder="请输入最大价格"></el-input>
						</span>
						<el-button style="margin-left: 10px;" type="text" @click='addTimes' v-if="index==0">新建</el-button>
						<el-button style="margin-left: 10px;" type="text" @click='editParams.buy_options.splice(index,1)' v-if="index!=0">删除</el-button>
					</div>
				</el-form-item>
				<el-form-item label="设置体重" >
					<el-popover placement="top" width="280" v-model="addweight">
						<div style="text-align: center; margin: 5px 0 10px 0">添加体重</div>
						<el-input size="mini" style="width: 130px;" placeholder="请输入" v-model="weight.minweight">
							<template slot="append">kg</template>
						</el-input>--
						<el-input size="mini" style="width: 130px;" placeholder="请输入" v-model="weight.maxweight">
							<template slot="append">kg</template>
						</el-input>
						<div style="text-align: center; margin-top: 10px">
							<el-button type="warning" size="mini" @click='sureweight'>确定</el-button>
						</div>
						<el-button size="mini" slot="reference" @click='addWeight'>新建</el-button>
					</el-popover>
					<div >
						<div class="weighttabs" v-for="(item,index) in editParams.plan_items" :key='index' @click="changetabs(index)">
							<div :class="['weighttab',{active:active==index}]">
								<span>{{item.weight_model.min_weight}}kg</span>--<span>{{item.weight_model.max_weight}}kg</span>
							</div>
							<div class="weightbtn">
								<el-popover placement="bottom" width="280" @hide="hidePopver(item)">
									<div style="text-align: center; margin: 5px 0 10px 0">编辑体重</div>
									<el-input size="mini" style="width: 130px;" placeholder="请输入" v-model="weight.minweight">
										<template slot="append">kg</template>
									</el-input>--
									<el-input size="mini" style="width: 130px;" placeholder="请输入" v-model="weight.maxweight">
										<template slot="append">kg</template>
									</el-input>
					
									<el-button size="mini" slot="reference" type="text" @click='editWeight(item,index)'>编辑</el-button>
								</el-popover>
								<!-- <span>编辑</span> -->
								<span style="margin-left: 10px;" @click="deletWeight(index)">删除</span>
							</div>
						</div>
					</div>
				</el-form-item>
				<div style="padding: 0 50px;" v-if="editParams.plan_items.length>0">
					<el-table :data="[editParams.plan_items[active].inside_body_plan]" default-expand-all row-class-name="row-expand-cove">
						<el-table-column prop="plan_name" label="计划名称">
						</el-table-column>
						<el-table-column prop="name" label="是否必开项">
							<template slot-scope="scope">
								<el-select v-model="scope.row.must_use" placeholder="请选择">
									<el-option label="是" :value="1"></el-option>
									<el-option label="否" :value="0">否</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="间隔天数">
							<template slot='header'>
								<span style="color: #FF0000;">*</span>
								<span class="m-l-10">间隔天数</span>
							</template>
							<template slot-scope="scope">
								<el-input style="width: 200px;" type='number' size='small' v-model.number="scope.row.next_plan_days"
								placeholder="请输入间隔天数"></el-input>
							</template>
						</el-table-column>
						<el-table-column type="expand">
							<template slot-scope="props">
								<el-table :data="props.row.plan_detail_items" show-summary style="width: 100%">
									<el-table-column prop="goods_name" label="商品名称">
									</el-table-column>
									<el-table-column prop="brand_name" label="品牌">
									</el-table-column>
									<el-table-column label="数量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.use_num" placeholder="请输入物品数量"></el-input>
											
										</template>
									</el-table-column>
									<el-table-column label="出库量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.out_num" placeholder="出库量"></el-input>
										
										</template>
									</el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-button size="mini" icon="el-icon-delete" type='danger' @click="props.row.plan_detail_items.splice(scope.$index,1)"></el-button>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180px">
					
							<template slot-scope="scope">
								<el-button size="mini" icon="el-icon-plus" type='warning' @click='dialogAddShop_state = true; planCurrentrow = scope.row;planType=0'>添加物品</el-button>
								
							</template>
						</el-table-column>
					</el-table>
					<el-table :data="[editParams.plan_items[active].outside_body_plan]" default-expand-all row-class-name="row-expand-cove">
						<el-table-column prop="plan_name" label="计划名称">
						</el-table-column>
						<el-table-column prop="name" label="是否必开项">
							<template slot-scope="scope">
								<el-select v-model="scope.row.must_use" placeholder="请选择">
									<el-option label="是" :value="1"></el-option>
									<el-option label="否" :value="0">否</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="间隔天数">
							<template slot='header'>
								<span style="color: #FF0000;">*</span>
								<span class="m-l-10">间隔天数</span>
							</template>
							<template slot-scope="scope">
								<el-input style="width: 200px;" type='number' size='small' v-model.number="scope.row.next_plan_days"
								placeholder="请输入间隔天数"></el-input>
							</template>
						</el-table-column>
						<el-table-column type="expand">
							<template slot-scope="props">
								<el-table :data="props.row.plan_detail_items" show-summary style="width: 100%">
									<el-table-column prop="goods_name" label="商品名称">
									</el-table-column>
									<el-table-column prop="brand_name" label="品牌">
									</el-table-column>
									<el-table-column label="数量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.use_num" placeholder="请输入物品数量"></el-input>				
										</template>
									</el-table-column>
									<el-table-column label="出库量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.out_num" placeholder="出库量"></el-input>
										
										</template>
									</el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-button size="mini" icon="el-icon-delete" type='danger' @click="props.row.plan_detail_items.splice(scope.$index,1)"></el-button>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180px">
					
							<template slot-scope="scope">
								<el-button size="mini" icon="el-icon-plus" type='warning' @click='dialogAddShop_state = true; planCurrentrow = scope.row;planType=1'>添加物品</el-button>
								
							</template>
						</el-table-column>
					</el-table>
				</div>
				

			</el-form>
		</div>
		<div v-if="dialogAddShop_state">
			<dialogNewGoods @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" :tree="tree" @submit='getgoods'></dialogNewGoods>
		</div>
		<div class="footer">
			<div style="margin: auto;">
				<el-button type="primary" size="small" :loading="loading" @click='submit'>确定</el-button>
				
			</div>
		</div>


	</div>
</template>

<script>
	import {
		setDewormingGroup,
		getDewormingGroupDl,
		getProductTypeList,
		getProductTypeDl,
	} from '../../../api/productApi.js'
	import dialogNewGoods from "../../../components/dialog_addShop.vue"
	import storeSelect from "../../../components/storeSelect.vue"
	export default {
		components: {
			storeSelect,
			dialogNewGoods
		},
		data() {
			return {
				rules: {
					title: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
				},
				tree:[{id:'602f1e88c904d9db7ccf3bec',children:[{id:'602f1e89c904d9db7ccf3bf6'},{id:'602f1e88c904d9db7ccf3bed'}]}],
				active:0,
				categoryData: [],
				productTypeIds: [],
				editParams: {
					groupId: '',
					title: '',
					category_info: {
						_id: '',
						name: '',
						code: '',
					},
					buy_back:1,
					group_type:'0',
					category_list: [],
					applyType: '0',
					buyWay: '0',
					buy_options: [{
						times: 3,
						give_times: 1,
						discount_rate: 0.1,
						min_price :0,
						max_price :0,
					}],
					checkout_replace: {
						support_replace: 0,
						replace_discount_rate: 0,
					},
					plan_items: [],
					join_commission: 1,
				},
				loading: false,
				storeIds: [],
				showShops: true,
				dialogAddShop_state: false,
				addweight: false,
				weight: {
					minweight: '',
					maxweight: '',
				},
				planType:0,
			}
		},
		methods: {
			isBack() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/group/group',
						query:{type:3}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						setDewormingGroup(this.editParams).then(res => {
							if (res.code == 0) {
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								this.$router.push({
									path: '/group/group',
									query:{type:3}
								})
							}
						})
					} else {

						return false;
					}
				});
			},
			getStores(data) {
				this.editParams.shop_info = data;
			},
			getProductTypeList() {
				getProductTypeList({
					category: '套餐'
				}).then(res => {
					if (res.code == 0) {
						this.categoryData = res.data[0].children;

					}
				})
			},
			changeCategory(val) {
				if (val.length > 0) {
					getProductTypeDl({
						id: val[val.length - 1]
					}).then(res => {
						if (res.code == 0) {
							this.editParams.category_info._id = res.data._id;
							this.editParams.category_info.name = res.data.name;
							this.editParams.category_info.code = res.data.code;
							this.editParams.category_list = res.data.parent_all;
						}
					})
				}
			},
			getDewormingGroupDl(id) {
				this.showShops = false;
				
				getDewormingGroupDl({
					id
				}).then(res => {
					if (res.code == 0) {
						this.productTypeIds = []
						this.editParams = res.data;
						this.productTypeIds.push(res.data.category_info._id);
						this.storeIds = this.editParams.shop_info.map(item => {
							return item.shop_id
						})
						this.showShops = true;
						

					}
				})
			},
			addTimes(){
				this.editParams.buy_options.push({
					times:2,
					give_times:0,
					discount_rate:0,
					min_price :0,
					max_price :0,
				})
			},
			sureweight() {
				if (!this.weight.minweight || !this.weight.maxweight) {
					this.$message({
						type: 'info',
						message: '请填写体重再进行确认操作'
					});
				} else {
					this.editParams.plan_items.push({
						_id: '',
						weight_model: {
							min_weight: this.weight.minweight,
							max_weight: this.weight.maxweight
						},
						inside_body_plan: {
							plan_name:'体内驱虫',
							next_plan_days:1,
							must_use:0,
							plan_detail_items:[]
						},
						outside_body_plan:{
							plan_name:'体外驱虫',
							next_plan_days:1,
							must_use:0,
							plan_detail_items:[],
						}
						
					});
					this.weight.minweight = '';
					this.weight.maxweight = '';
					this.addweight = false;
			
				}
			},
			addWeight() {
				this.weight.minweight = '';
				this.weight.maxweight = '';
			},
			hidePopver(item) {
				item.weight_model.min_weight = this.weight.minweight;
				item.weight_model.max_weight = this.weight.maxweight;
			},
			editWeight(item) {
				this.weight.minweight = item.weight_model.min_weight;
				this.weight.maxweight = item.weight_model.max_weight;
			},
			deletWeight(index) {
				this.$confirm('你确定删除该体重及配置项, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.editParams.plan_items.splice(index, 1)
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			changetabs(index){
				this.active = index;
			},
			getgoods(data){
				// 0为体内1为体外
			
				if(this.planType==0){
					this.editParams.plan_items[this.active].inside_body_plan.plan_detail_items.push({
						goods_type:data.goodsType,
						goods_id:data.goodsItem.medical_id,
						use_num:1,
						out_num:1,
						goods_name:data.goodsItem.title,
						brand_name:data.goodsItem.brand_name,
					})
				}else{
					this.editParams.plan_items[this.active].outside_body_plan.plan_detail_items.push({
						goods_type:data.goodsType,
						goods_id:data.goodsItem.medical_id,
						use_num:1,
						out_num:1,
						goods_name:data.goodsItem.title,
						brand_name:data.goodsItem.brand_name,
					})
				}
			}
		},
		created() {
			this.getProductTypeList();
			if (this.$route.query.id) {
				this.getDewormingGroupDl(this.$route.query.id)
			} else {
				this.storeIds = this.$store.state.userInfo.shops.map(item => {
					return item.shop_id
				})
				this.editParams.shop_info = this.$store.state.userInfo.shops
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page {
		.wrap{
			background-color: #fff;
			padding-bottom: 20px;
		}
		.tit {
			font-size: 16px;
			margin-bottom: 28px;
			height: 40px;
			line-height: 40px;
			border-radius: 3px;
			padding-left: 10px;

			.name {
				padding-left: 5px;
				border-left: 2px solid #F5882A;
			}
		}

		.footer {
			background-color: #fff;
			position: fixed;
			bottom: 0;
			height: 50px;
			line-height: 50px;
			display: flex;
			justify-content: space-between;
			left: 220px;
			right: 0;
			padding-left: 20px;
			z-index: 200;
		}
		.weighttabs {
			display: inline-block;
			border: 1px solid rgba(0, 0, 0, 0.15);
			border-radius: 5px;
			margin-right: 10px;
			vertical-align: top;
		
			.weighttab {
				padding: 0 10px;
			}
		
			.active {
				background-color: #F5882A;
				color: #fff;
			}
		
			.weightbtn {
				padding: 0 10px;
				border-top: 1px solid rgba(0, 0, 0, 0.15);
				font-size: 12px;
			}
		}
	}
</style>
